import { BASE_URLS, ENVIRONMENT_MODE } from "../../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../../config/axiosInterceptor";
import { CreateUnitsByCompanyIdType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const createUnitByCompanyId = (
  id: string,
  payload: CreateUnitsByCompanyIdType
): Promise<AxiosResponse<CreateUnitsByCompanyIdType>> => {
  return axios.put(`${baseURL}createUnitByCompanyId/${id}`, payload);
};

export const deleteUnitsById = (id: string): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteUnitsById/${id}`);
};

export const deleteUnit = (
  unitIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteUnit`, { data: unitIds });
};
